import { createContext, useCallback, useReducer } from 'react'
import { globalReducer } from '../../providers/globalContext'
import { initialState } from './initialState'
import { InitialState } from './types/initialState'
import { Props } from './types/props'
import { companiesServiceFetch } from '../../utils/constants/callService'
import { LocaleNameType, setLocalStorage } from '../../utils/crud/crypt'

export const GlobalContext = createContext({} as InitialState)

export const ContextProvider: React.FC<Props> = ({ children, colors, handleTheme }) => {
  const [state, dispatch] = useReducer(globalReducer, initialState['state'])
  const companySetting = useCallback(async ({ companyId, userId }: { companyId?: string; userId: string }) => {
    if (companyId) {
      let brandy = await companiesServiceFetch.getBranding({ id: userId })
      const color15 = brandy?.styles?.color15,
        color16 = brandy?.styles?.color16,
        color21 = brandy?.styles?.color21,
        bigLogo = brandy?.assets?.find(item => item.appbar),
        smallLogo = brandy?.assets?.find(item => item.appbarsmall)
      const color = {
        ...colors,
        ...color15 && { primaryEndpoint: color15 },
        ...color16 && { secondaryEndpoint: color16 },
        ...color21 && { contrastEndpoint: color21 }
      }
      const brandyCustome = {
        ...brandy,
        logo: {
          big: bigLogo?.appbar,
          small: smallLogo?.appbarsmall
        }
      }
      const body = {
        brandy: brandyCustome,
        color
      }
      handleTheme({ color })
      setLocalStorage({ name: LocaleNameType.SETTING, body })
    }
    return true
  }, [])

  return (
    <GlobalContext.Provider
      value={{
        state,
        dispatch,
        colors: colors,
        handleTheme,
        companySetting
      }}
    >
      {children}
    </GlobalContext.Provider>
  )
}
